// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___TQt4R";
var _2 = "styles-module__searchResult___KAdIK";
export { _1 as "container", _2 as "searchResult" }
